import { Observable } from 'rxjs';
import { ConfigurationRepository } from '../../repositories/configuration.repository';
import { UseCase } from '../../base/use-case';
import { MetodoPagoSaludModel } from '../../models/configuration/metodo-pago-salud.model';

export class GetMetodoPagoSaludUseCase implements UseCase<void, MetodoPagoSaludModel>{
	constructor(private configRepository: ConfigurationRepository) { }
	execute(): Observable<MetodoPagoSaludModel> {
	  return this.configRepository.getMetodoPagoSalud();
	}
}